import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import sidebar from "./modules/sidebar";
import header from "./modules/header";
import footer from "./modules/footer";
import auth from "./modules/auth";
import residence from "./modules/residence";
import setting from "./modules/setting";
import translation from "./modules/translation";
import theme from "./modules/theme";
import field_project from "./modules/field_project";
import tags from "./modules/tags";
import project from "@/store/modules/project";
import news from "./modules/news";
import seo from "./modules/seo";
import career from "./modules/career";
import contact from "./modules/contact";
import cv from "./modules/cv";
import portfolio from "./modules/portfolio";
import position from "./modules/position";
import consultationForm from "./modules/consultationForm";
import process from "./modules/process";
import service from "./modules/service";
import technology from "./modules/technology";
import banner from "./modules/banner";
import partner from "@/store/modules/partner";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters,
  mutations,
  actions,
  modules: {
    partner,
    field_project,
    process,
    service,
    technology,
    banner,
    consultationForm,
    career,
    contact,
    cv,
    portfolio,
    position,
    tags,
    project,
    news,
    seo,
    auth,
    setting,
    residence,
    navigations: {
      namespaced: true,
      modules: {
        header,
        sidebar,
        footer,
      },
    },
    scheme: {
      namespaced: true,
      modules: {
        theme,
      },
    },
    translation,
  },
});
